export const SIMULATION_STEPS = Object.freeze({
  FORM_BASIC_INFO: {
    id: 'informacoes-basicas',
    title: 'Informações básicas',
    index: 1,
    render: true,
  },
  FORM_USAGE: {
    id: 'consumo',
    title: 'Dados de consumo',
    index: 2,
    render: true,
  },
  FORM_PROPOSAL: {
    id: 'proposta',
    title: 'Simulação',
    index: 3,
    render: true,
  },
  FORM_PERSONAL_DATA: {
    id: 'dados-pessoais',
    title: 'Dados pessoais',
    index: 4,
    render: true,
  },
  /* END STATES */
  END_JOURNEY_APARTMENT: {
    id: 'fim-apartamento',
    hideStepper: true,
  },
  END_JOURNEY_STORE_NOT_FOUND: {
    id: 'fim-loja-nao-encontrada',
    hideStepper: true,
  },
  END_JOURNEY_STORE_PROPOSAL_SENT: {
    id: 'fim-loja-proposta-enviada',
    hideStepper: true,
  },
  END_CONFIRMATION: {
    id: 'confirmacao',
    hideStepper: true,
  },
  END_JOURNEY_FINAL: {
    id: 'final',
    hideStepper: true,
  },
  ERROR_GENERIC: {
    id: 'error',
    hideStepper: true,
    title: 'Ops! Algo deu errado.',
    message: 'Ocorreu um erro inesperado. Tente novamente mais tarde.',
  },
});

export const SIMULATION_TITLES = Object.freeze({
  ETAPA_1: 'Informações básicas | Santander Financiamentos',
  ETAPA_2: 'Dados de consumo | Santander Financiamentos',
  ETAPA_3: 'Simulação | Santander Financiamentos',
  ETAPA_4: 'Dados pessoais | Santander Financiamentos',
});
